import PrivacyInfo from './privacy-info';
export default PrivacyInfo;
